<section class="add-service-codes">
  <div class="header-section mb-20 px-5">
    <h2>
      <mat-icon class="me-8" style="vertical-align: sub;">science</mat-icon>
      Add Service Request Codes
    </h2>
    <p class="subtitle-text-color-2">Define reusable service request codes for lab tests, imaging, and procedures</p>
  </div>

  <mat-card>
    <mat-card-content style="padding: 0px !important">
      <ng-container *ngIf="!loading; else loadingState">
        @if (formMetaData && formFields) {
        <div style="width: 650px; max-width: 100%;">
          <app-dynamic-forms-v2 [formMetaData]="formMetaData" [formFields]="formFields"
            (formSubmitted)="onFormSubmit($event)">
          </app-dynamic-forms-v2>
        </div>
        }
      </ng-container>

      <ng-template #loadingState>
        <div class="loading-state">
          <mat-icon>hourglass_empty</mat-icon>
          <p>Loading form fields...</p>
        </div>
      </ng-template>
    </mat-card-content>
  </mat-card>
</section>